import { EventBus } from '@/event-bus.js';

export default class EmailStatusEvent {
  constructor(statusEvent) {
    EventBus.$emit('emailStatusEvent', statusEvent);
  }
}
